import React, { useState, useEffect } from 'react';
import styles from './ThemeToggle.module.css';

const ThemeToggle: React.FC = () => {
  const [isDark, setIsDark] = useState<boolean>(false);

  useEffect(() => {
    // Sistem tercihini kontrol et
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const savedTheme = localStorage.getItem('theme');
    
    if (savedTheme) {
      setIsDark(savedTheme === 'dark');
      document.documentElement.setAttribute('data-theme', savedTheme);
    } else {
      setIsDark(prefersDark);
      document.documentElement.setAttribute('data-theme', prefersDark ? 'dark' : 'light');
    }
  }, []);

  const toggleTheme = (): void => {
    const newTheme = isDark ? 'light' : 'dark';
    setIsDark(!isDark);
    document.documentElement.setAttribute('data-theme', newTheme);
    localStorage.setItem('theme', newTheme);
  };

  const stylesRecord = styles as Record<string, string>;
  return (
    <button 
      className={`${stylesRecord['themeToggle'] || ''} ${isDark ? (stylesRecord['themeToggle--dark'] || '') : ''}`}
      onClick={toggleTheme}
      title={isDark ? 'Light mode\'a geç' : 'Dark mode\'a geç'}
      aria-label={isDark ? 'Light mode\'a geç' : 'Dark mode\'a geç'}
    >
      <div className={stylesRecord['themeToggle__track'] || ''}>
        <div className={`${stylesRecord['themeToggle__thumb'] || ''} ${isDark ? (stylesRecord['themeToggle__thumb--dark'] || '') : ''}`}>
          <span className={stylesRecord['themeToggle__icon'] || ''}>
            {isDark ? '☀️' : '🌙'}
          </span>
        </div>
      </div>
    </button>
  );
};

export default ThemeToggle;

